import React from 'react';
import { BrowserRouter as Router} from 'react-router-dom';
import './App.scss';
import AppRoutes from "./routes";
import { SettingsProvider } from './contexts/SettingsContext';
import { HelmetProvider } from 'react-helmet-async';
import Maintenance from './components/Maintenance';
import ComingSoon from './components/ComingSoon';

const App = () => {
  const isMaintenance = process.env.REACT_APP_MAINTENANCE_MODE === 'true';
  const isComingSoon = process.env.REACT_APP_COMING_SOON_MODE === 'true'; // corrected spelling

  let content = <AppRoutes />;

  if (isMaintenance) {
    content = <Maintenance />;
  } else if (isComingSoon) {
    content = <ComingSoon />;
  }

  return (
    <HelmetProvider>
      <SettingsProvider>
        <Router>
          {content}
        </Router>
      </SettingsProvider>
    </HelmetProvider>
  );
};

export default App;
